import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { left_arrow, toggle_off, toggle_on } from "../../assets/imgs";
import { useLazyRolesListViewQuery, useLazyRolesPermissionsQuery, useRolesListAddMutation, useRolesListEditMutation } from "../redux/api/api";
import { toast } from "react-toastify";

const AddRole = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [role, setRole] = useState("");
    const [permissions, setPermissions] = useState([]);
    const [permissionList, setPermissionList] = useState([]);
    const role_id = localStorage.getItem("roleid");
    const [loader, setLoader] = useState(false);
    const [selectedPermissions, setSelectedPermissions] = useState({});
    const rolePermissions = JSON.parse(localStorage.getItem('permissions'))

    console.log('per', permissions)

    const type = location?.state?.type;
    const id = location?.state?.id;


    const [rolesListAddApi] = useRolesListAddMutation();
    const [rolesListEditApi] = useRolesListEditMutation();
    const [rolesListViewApi] = useLazyRolesListViewQuery();
    const [permissionsRoleApi] = useLazyRolesPermissionsQuery();

    const rolesAdd = () => {
        if (!role) {
            toast.error("Enter Role");
            return;
        }
        const formdata = new FormData();
        formdata.append("role", role);
        permissions?.map((item, ind) => {
            formdata.append(`permissions[${ind}]`, item);
        })
        setLoader(true);
        rolesListAddApi(formdata)
            .unwrap()
            .then((res) => {
                if (res?.status == "success") {
                    setLoader(false);
                    toast.success(res?.message);
                    navigate(-1);
                    setRole("");
                    setSelectedPermissions("");
                }
            })
            .catch((err) => {
                console.log("err", err);
            }).finally(() => {
                setLoader(false)
            })
    }
    const rolesEdit = () => {
        const formdata = new FormData();
        formdata.append("role", role);
        permissions?.map((item, ind) => {
            formdata.append(`permissions[${ind}]`, item);
        })
        setLoader(true);
        rolesListEditApi({ payload: formdata, id: id })
            .unwrap()
            .then((res) => {
                if (res?.status == "success") {
                    setLoader(false)
                    toast.success(res?.message);
                    navigate(-1);
                    setRole("");
                    setSelectedPermissions("");
                }

            })
            .catch((err) => {
                console.log("err", err);
            }).finally(() => {
                setLoader(false)
            })
    }


    const rolesView = (id) => {
        rolesListViewApi(id)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                setRole(res?.role?.role);
                let temp = []
                res?.role?.permissions?.map((item, ind) => {
                    temp.push(item?.id)
                })
                setPermissions(temp)
            })
            .catch((err) => {
                console.log("err", err);
            })
    }
    const rolesPermission = () => {
        permissionsRoleApi()
            .unwrap()
            .then((res) => {
                console.log(res, "Roles");
                if (res?.status == "success") {

                    if (role_id == 4) {
                        setPermissionList(res?.data);
                    } else {
                        let filtered = res?.data?.filter((item) => {
                            if (item?.id != 62 && item?.id != 63) {
                                return true;
                            }
                        });
                        setPermissionList(filtered);
                    }
                }
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    useEffect(() => {
        if (id) {
            rolesView(id);
        }
        rolesPermission();
    }, []);

    const selectRoles = () => {
        let ids = [];
        permissionList.map((item) => {
            item.permissions.map((d) => {
                ids.push(d.id);
            });
        });
        if (permissions.length < ids.length) {
            setPermissions(ids);
        } else {
            setPermissions([]);
        }
    };


    // Handle toggling of permissions
    const handlePermissionToggle = (id) => {
        let temp = [...permissions]
        let inx = temp.indexOf(id)
        if (temp.includes(id)) {
            temp.splice(inx, 1)
        } else {
            temp.push(id)
        }
        setPermissions(temp);
    };


    return (
        <div className="dashRightView home_section" >
            <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
                Roles
            </h2>

            <div className='d-flex ac-js gap-2'
                onClick={() => navigate(-1)}
            >
                <img src={left_arrow} className='leftArrow mb-3' />
                <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">Back</p>
            </div>
            <div className="d-flex ac-jb mb-3">
                <div className="col-md-3">
                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                        Role Name
                    </h4>
                    <input type="text" readOnly={type == "view" ? true : false} value={role} onChange={(e) => setRole(e.target.value)} className="input-pop ps-2 w-100" placeholder="" />
                </div>
                {type != "view" && (
                    <div className="">
                        <button onClick={() => { selectRoles(); }} className="select-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-16 fs-xxl-18  white"  >
                            Select All
                        </button>
                    </div>
                )}
            </div>
            <div className='input-role p-3 '>
                <h4 className="f3 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 mt-2 primary1">
                    Permission :
                </h4>
                <div className="d-flex flex-wrap mt-2">
                    {permissionList?.map((item, id) => {
                        return (
                            <div className="col-md-3 mt-3 ps-1">
                                <p className="f3 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18">
                                    {item?.module_type}
                                </p>

                                <div className="d-flex ac-js">
                                    <div>

                                        {item?.permissions?.map((permission, index) => {
                                            const isSelected = permissions?.includes(
                                                permission.id
                                            );
                                            return (
                                                <div className="d-flex ac-js gap-2 mb-2">
                                                    <img
                                                        src={isSelected ? toggle_on : toggle_off}
                                                        className="roles-icon pointer"
                                                        alt=""
                                                        onClick={() => {
                                                            if (type != "view") {
                                                                handlePermissionToggle(permission.id);
                                                            }
                                                        }}
                                                    />
                                                    <p className=" f1 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ">
                                                        {permission?.name}
                                                    </p>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                {type != "view" && (
                    <div className="role-btn">
                        {(rolePermissions?.includes('CAN-ADD-ROLE') || rolePermissions?.includes('CAN-EDIT-ROLE')) &&
                            <button onClick={() => { type == "edit" ? rolesEdit() : rolesAdd() }} className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
                                {loader && (
                                    <div
                                        class="spinner-border spinner-border-sm "
                                        role="status"
                                        style={{ marginRight: "5px" }}
                                    ></div>
                                )}  Submit
                            </button>
                        }
                    </div>
                )}
            </div>
        </div>
    )
}

export default AddRole